import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import cloudBackupImg1 from '../../../../assets/services/hostedinfrastructure/icons/infrastructure.svg';

const DisasterSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Enterprise-Grade Cloud-Hosting & Next-Gen Security</h1>
          <p>
            With Synectiks Cloud Hosted Services, you can focus on your business needs instead of spending the time and money it takes to plan, procure, secure, and manage the right infrastructure that meets your business demands. Synectiks Secure Cloud Hosting helps you run servers, workloads, Kubernetes, websites and modern applications with strong security, reliable performance, and predictable costs. We provide infrastructure, security controls, backup/DR, and 24x7 operations support, so your team can focus on business delivery instead of managing hardware, procurement, upgrades, and day-to-day infrastructure overhead.
          </p>
        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={cloudBackupImg1} alt="Cloud Backup Illustration" />
        </div>
      </div>
    </section>
  );
};

export default DisasterSection;
